import React, { useState } from 'react';
import DiscoveryView from './DiscoveryView';
import QueueView from './QueueView';
import StatsView from './StatsView';

const TABS = [
  { key: 'discovery', label: '🔍 Keşif' },
  { key: 'queue', label: '📋 Havuz' },
  { key: 'stats', label: '📊 İstatistik' },
];

// Ust duzey kapsayici - is mantigi tamamen alt bilesenlerde (Discovery/Queue/Stats),
// bu bilesen sadece ic sekme gecisini yonetir. AdminPanel.js'e sadece bu tek
// bilesen devredilir (Firma Yonetim Ekrani'ndaki delegasyon deseniyle ayni).
const CallCenterBoard = () => {
  const [tab, setTab] = useState('discovery');

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, borderBottom: '1px solid #e5e7eb', paddingBottom: 10 }}>
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding: '8px 16px',
              borderRadius: 6,
              border: 'none',
              cursor: 'pointer',
              fontWeight: 600,
              background: tab === t.key ? '#2563eb' : '#f1f5f9',
              color: tab === t.key ? '#fff' : '#334155',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'discovery' && <DiscoveryView />}
      {tab === 'queue' && <QueueView />}
      {tab === 'stats' && <StatsView />}
    </div>
  );
};

export default CallCenterBoard;
